import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ShopInner from '../Components/Shop/ShopInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { usePageBanner } from '../hooks/usePageBanner'

function Shop() {
    const { title, bgImage } = usePageBanner({
        pageSlug: 'shop',
        fallbackTitle: 'Shops',
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <ShopInner />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Shop
